/*eslint-disable*/
import React, { useState } from 'react';
import Script from 'next/script';
import classNames from "classnames";
import PinDrop from "@mui/icons-material/PinDrop";
import Phone from "@mui/icons-material/Phone";
import BusinessCenter from "@mui/icons-material/BusinessCenter";
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinksTribalism from "components/Header/HeaderLinksTribalism.js";
import GridContainer from "/components/Grid/GridContainer.js";
import GridItem from "/components/Grid/GridItem.js";
import InfoArea from "/components/InfoArea/InfoArea.js";
import CustomInput from "/components/CustomInput/CustomInput.js";
import Button from "/components/CustomButtons/Button.js";
import Footer from "components/Footer/TribalismFooter.js";
import axios from 'axios';
import TribalismGoogleMap from '/tribalism-component/google-map';
import styles from "pages-sections/services/ServicesSections.module.scss";
import { useRouter } from "next/router";

export default function ContactUsPage() {
  const router = useRouter();
  const classes = styles;
  const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;

  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null },
  });

  const [inputs, setInputs] = useState({
    yourName: '',
    emailAddress: '',
    phone: '',
    message: '',
  });

  const handleServerResponse = (ok, msg) => {
    if (ok) {
      setStatus({ submitted: true, submitting: false, info: { error: false, msg } });
      setInputs({ yourName: '', emailAddress: '', phone: '', message: '' });
      if (typeof window !== 'undefined' && window.grecaptcha?.reset) window.grecaptcha.reset();
      // ✅ do the redirect
      router.push("/thank-you");
    } else {
      setStatus({ submitted: false, submitting: false, info: { error: true, msg } });
    }
  };

  const handleOnChange = (e) => {
    e.persist();
    setInputs(prev => ({ ...prev, [e.target.id]: e.target.value }));
    setStatus({ submitted: false, submitting: false, info: { error: false, msg: null } });
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    setStatus(prev => ({ ...prev, submitting: true }));

    try {
      const token = window.grecaptcha?.getResponse();
      if (!token) {
        setStatus({ submitted: false, submitting: false, info: { error: true, msg: 'Please complete the reCAPTCHA.' } });
        return;
      }

      const payload = {
        ...inputs,
        'g-recaptcha-response': token,
      };

      await axios({
        method: 'POST',
        url: 'https://formspree.io/f/mvodqwqo',
        data: payload,
        headers: { Accept: 'application/json' },
      });

      handleServerResponse(true, 'Thank you, your message has been submitted.');
    } catch (error) {
      const msg = error?.response?.data?.error || error?.message || 'Submission failed';
      handleServerResponse(false, msg);
    }
  };

  return (
    <div>
      <Script src="https://www.google.com/recaptcha/api.js" strategy="afterInteractive" />

      <Header
        brand="/img/clients/TribalismLogoRev.webp"
        links={<HeaderLinksTribalism dropdownHoverColor="info" />}
        fixed
        color="dark"
        title="Contact Us - Tribalism"
        image="/img/bg10-small.webp"
        url="https://www.tribalism.com.au/contact-us"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. Contact us today and use our expertise to help your business grow !"
        changeColorOnScroll={{ height: 300, color: "info" }}
      />
      <div className={classes.bigMap}>
        <TribalismGoogleMap />
      </div>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.contactContent}>
          <div className={classes.container}>
            <h2 className={classes.title}>Contact us here to get started!</h2>
            <GridContainer>
              <GridItem md={6} sm={6}>
                <p>
                  If you have any questions related to our services or anything else related to our business, please get in touch below. We&apos;ll respond within 24hrs. Thank you! 😀
                  <br /><br />
                </p>

                <form onSubmit={handleOnSubmit}>
                  <CustomInput
                    labelText="Your Name"
                    id="yourName"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{ onChange: handleOnChange, value: inputs.yourName }}
                  />
                  <CustomInput
                    labelText="Email address"
                    id="emailAddress"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{ onChange: handleOnChange, value: inputs.emailAddress }}
                  />
                  <CustomInput
                    labelText="Phone"
                    id="phone"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{ onChange: handleOnChange, value: inputs.phone }}
                  />
                  <CustomInput
                    labelText="Your message"
                    id="message"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{ multiline: true, rows: 6, onChange: handleOnChange, value: inputs.message }}
                  />

                  <div style={{ margin: '12px 0' }}>
                    <div className="g-recaptcha" data-sitekey={siteKey} />
                  </div>

                  <div className={classes.textCenter}>
                    <Button
                      color="primary"
                      round
                      className={classes.pullRight}
                      type="submit"
                      disabled={status.submitting}
                    >
                      {status.submitting ? 'Submitting…' : status.submitted ? 'Submitted' : 'Send Message'}
                    </Button>
                  </div>
                </form>

                {status.info.error && <div className="error">Error: {status.info.msg}</div>}
                {!status.info.error && status.info.msg && <p>{status.info.msg}</p>}
              </GridItem>

              <GridItem md={4} sm={4} className={classes.mlAuto}>
                <InfoArea
                  className={classes.info}
                  title="Warning Fraudlent Job Posts on Facebook!!"
                  description={
                    <>
                      <span>If you are applying for a job with us please be aware of recent fraudulent job scams on facebook community groups!</span>
                      <br /><br />
                      <span>See our Blog post detailing this <a href="/blog-post/2025/02/facebook-scams">here</a></span>
                    </>
                  }
                  icon={PinDrop}
                  iconColor="primary"
                />
                <InfoArea
                  className={classes.info}
                  title="Find us at the office"
                  description={
                    <>
                      <span>Suite 147</span>
                      <br />
                      <span>585 Little Collins Street</span>
                      <br />
                      <span>Melbourne, 3000</span>
                      <br />
                      <span>Victoria, Australia</span>
                    </>
                  }
                  icon={PinDrop}
                  iconColor="primary"
                />
                <InfoArea
                  className={classes.info}
                  title="Give us a ring"
                  description={
                    <>
                      <span>Tribalism Team</span>
                      <br />
                      <span>+61 1300 151 387</span>
                      <br />
                      <span>Mon - Fri, 9:00-17:00</span>
                    </>
                  }
                  icon={Phone}
                  iconColor="primary"
                />
                <InfoArea
                  className={classes.info}
                  title="Legal Information"
                  description={
                    <>
                      <span>TRIBALISM PTY LTD</span>
                      <br />
                      <span>ABN · 15 636 700 797</span>
                    </>
                  }
                  icon={BusinessCenter}
                  iconColor="primary"
                />
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
